import { Target } from "lucide-react";

const EX_TAG = {
  scheduled: "tag-cyan",
  in_progress: "tag-amber",
  complete: "tag-green",
};

export default function ExerciseList({ exercises }) {
  return (
    <div className="flat-card p-6" data-testid="sd-exercises-card">
      <div className="overline">// 03_RECENT_EXERCISES</div>
      <h2 className="font-display font-bold text-2xl uppercase mt-1 mb-4">Track Exercises</h2>
      <div className="space-y-3 max-h-72 overflow-auto">
        {exercises.length === 0 && (
          <div className="text-sm text-[var(--text-2)]">No exercises for this track.</div>
        )}
        {exercises.map((x) => (
          <div key={x.id} className="border border-[var(--border)] p-3" data-testid={`sd-ex-${x.code}`}>
            <div className="flex items-start justify-between">
              <div className="font-mono text-[10px] text-[var(--cyan)]">{x.code}</div>
              <span className={`tag ${EX_TAG[x.status]}`}>{x.status.replace("_", " ")}</span>
            </div>
            <div className="font-display font-bold uppercase text-sm mt-0.5">{x.title}</div>
            <div className="font-mono text-[10px] text-[var(--text-2)] tracking-widest uppercase mt-1 flex items-center gap-1">
              <Target size={10} /> {new Date(x.scheduled_at).toLocaleDateString()} &middot; {x.difficulty}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
